<script>
  export let messages;
  let openWindow = null;
  let riddleStatus = 0;
  let riddleValue = "";
  let wizardNum = 0;

  function resetRiddle() {
    openWindow = null;
    riddleStatus = 0;
    wizardNum = 0;
    riddleValue = "";
  }
</script>

{#if openWindow != null}
  <div class="window_bg">
    {#if openWindow == "m2"}
      <div class="window">
        <div class="title-bar">
          <div class="title-bar-text">Berichtgeving</div>
          <div class="title-bar-controls">
            <button aria-label="Minimize"></button>
            <button aria-label="Maximize"></button>
            <button aria-label="Close"></button>
          </div>
        </div>
        <div class="window-body">
          <p>
            U heeft <b>1</b> nieuw bericht!
          </p>
          <b>Van:</b> Jan Schakelaar
          <p>
            Ik ben zeer ontevreden met deze koffiebonen! Ze zijn te sterk! Heb
            ze retour gestuurd. Ze zullen aankomen onder de trap op de 2e
            verdieping.
          </p>
        </div>
      </div>
    {/if}
    {#if openWindow == "m1"}
      <div class="window">
        <div class="title-bar">
          <div class="title-bar-text">Bericht herstellen</div>
          <div class="title-bar-controls">
            <button aria-label="Minimize"></button>
            <button aria-label="Maximize"></button>
            <button aria-label="Close"></button>
          </div>
        </div>
        <div class="window-body">
          {#if riddleStatus == 0 || riddleStatus == -1}
            <b>Oh nee!</b>
            <p>
              We weten niet meer van wie dit bericht kwam... Hier is wat we wel
              weten
            </p>

            <p>
              Ik ben leergierig en ben goed in lezen en schrijven, zeker voor
              mijn leeftijd. Boos, ben ik! Maar zo voel ik me helemaal niet.
            </p>

            <div class="field-row">
              <label for="text21">Wie ben ik?</label>
              <input
                id="text21"
                autofocus
                bind:value={riddleValue}
                type="text"
              />

              <button
                on:click={() => {
                  if (
                    ["vayen", "vayén", "vayèn"].indexOf(
                      riddleValue
                        .trim()
                        .split(" ")[0]
                        .split(" ")[0]
                        .toLowerCase()
                        .trim(),
                    ) > -1
                  ) {
                    riddleStatus = 1;
                  } else {
                    riddleStatus = -1;
                  }
                }}>Controleren</button
              >
            </div>
            {#if riddleStatus == -1}
              <b>Helaas, dat is niet goed...</b>
            {/if}
          {:else}
            <b>Goed gedaan!</b> Je herkent je eigen dochter! Het systeem lijkt
            weer online te zijn, je kan weer kijharde knaken verdienen!
            <button
              on:click={() => {
                resetRiddle();
                messages[0].status = 1;
                messages[0].from = "Vayèn Boos";
                setTimeout(function () {
                  openWindow = "m2";
                }, 2000);
              }}>Afsluiten</button
            >
          {/if}
        </div>
      </div>
    {/if}
  </div>
{/if}
<table>
  <thead>
    <tr>
      <th>Van</th>
      <th>Onderwerp</th>
      <th>Bericht</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    {#each messages as message}
      <tr>
        <td>{message.from}</td>
        <td>{message.subject}</td>
        <td>{message.message}</td>
        {#if message.status == 1}
          <td>OK</td>
        {:else}
          <td>
            Error: Corrupt!
            <button
              on:click={() => {
                openWindow = message.toOpen;
                riddleStatus = 0;
              }}>Herstellen</button
            >
          </td>
        {/if}
      </tr>
    {/each}
  </tbody>
</table>

<style>
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  th {
    background-color: #f2f2f2;
  }
  .window_bg {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 99999;
    background: rgba(0, 0, 0, 0.5);
    display: flex; /* Establishes flex container */
    justify-content: center; /* Centers children horizontally */
    align-items: center; /* Centers children vertically */
  }
  .window_bg .window {
    max-width: 500px;
    width: 100%;
  }
</style>
